const getPassedQueue = (queues) => {
  return queues.filter((item) => item?.is_passed);
};

const getPrimaryQueue = (queues) => {
  return queues.filter((item) => !item?.is_passed || item?.is_passed);
};

const getCompletedQueue = (queues) => {
  return queues.filter(
    (item) => item?.queue_status?.name?.toLowerCase() === "done",
  );
};

export { getPassedQueue, getPrimaryQueue, getCompletedQueue };
